import { IconMap } from '@workspace/ui/common/IconMap';
import { ButtonVariant } from '@workspace/ui/common/Buttons/Button';
import { ContactSupportButton } from '../contact-support.types';

export const isIconKey = (n: unknown): n is keyof typeof IconMap => typeof n === 'string' && n in IconMap;

export const getButtonVariant = (
  btn: ContactSupportButton,
): Extract<ButtonVariant, 'primary' | 'secondary' | 'tertiary'> => {
  if (btn.variant === 'primary') return 'primary';
  if (btn.variant === 'tertiary') return 'tertiary';
  return 'secondary';
};
